import React from "react";
import {useCountertops} from "../../contexts/countertopsContext";
import {TextArea} from "devextreme-react/text-area";

export function NoteControl() {
    const context = useCountertops();

    return (
        <>
            <p className={"box-header"}>
                Note
            </p>
            <div>
                <TextArea height={90} value={context.note} valueChangeEvent={'blur'} onValueChanged={(e) => {
                    context.updateNote(e.value ?? '');
                }}></TextArea>
            </div>
        </>
    );
}
